export function AdjustMonthDay(str) {
  var str2 = str.replace(/-| |\./g, "/");
  var s2 = str2.split("/");
  if (s2.length == 3) {
    // DDMMYYYY
    var p0 = parseInt(s2[0]);
    var p1 = parseInt(s2[1]);
    if (!isNaN(p0) && !isNaN(p1)) {
      if (p0 < 35 && p1 < 35) return s2[1] + "/" + s2[0] + "/" + s2[2];
    }
  }
  return str2;
}
